export default "__VITE_ASSET__B$U858YQ__"